import { formatNumber, WidgetWrapper } from '@agentselly/ui';

interface Props {
  readonly yearlyCostCurrently: number;
  readonly yearlyCostSanitized: number;
  readonly progressCurrently: number;
  readonly progressSanitized: number;
}

export function PartnerEnergyCostWidget(props: Props) {
  return (
    <WidgetWrapper title="Energiekosten pro Jahr">
      <div className="flex flex-col gap-4">
        <Progress
          label="Ihre Immobilie"
          progress={props.progressCurrently || 0}
          value={props.yearlyCostCurrently || 0}
          unit="CHF"
        />
        <Progress
          label="Nach Sanierung"
          progress={props.progressSanitized || 0}
          value={props.yearlyCostSanitized || 0}
          unit="CHF"
        />
      </div>
    </WidgetWrapper>
  );
}

function Progress(props: {
  readonly label: string;
  readonly progress: number;
  readonly value: number;
  readonly unit: string;
}) {
  const formattedValue = formatNumber(props.value);

  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center w-full gap-2 sm:gap-4">
      <div className="w-full sm:w-[200px]">{props.label}</div>
      <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded-xl overflow-hidden">
        <div
          className="h-full bg-primary-500"
          style={{ width: `${Math.round(props.progress * 100)}%` }}
        />
      </div>
      <div className="w-24 shrink-0">
        <span className="font-bold">{formattedValue}</span>&nbsp;{props.unit}
      </div>
    </div>
  );
}
